import React from 'react';
import contact1 from '../../assets/contacts/contact1.svg';
import ContactElement from './ContactElement';


const Contacts = () => {
    const details = {
        type: "Contact us!",
        title: "Need support or have a query ?",
        img: contact1,
        submit: "Submit"
    }

    return (
        <div className="pt-[100px] md:pt-[120px]"> 
            <ContactElement details={details} />
        </div>

    )
}

export default Contacts
